import { render, staticRenderFns } from "./LeftBubble.vue?vue&type=template&id=0408fd12"
import script from "./LeftBubble.vue?vue&type=script&lang=js"
export * from "./LeftBubble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports